import React from 'react';

export const ContractIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="20"
    viewBox="0 0 16 20"
  >
    <defs>
      <path
        id="contract-a"
        d="M2.5 0h15a.5.5 0 0 1 .5.5v19a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zm3.75 4a.75.75 0 0 0 0 1.5h7.5a.75.75 0 1 0 0-1.5h-7.5zm0 2.5a.75.75 0 0 0 0 1.5h7.5a.75.75 0 1 0 0-1.5h-7.5zm0 5a.75.75 0 1 0 0 1.5h7.5a.75.75 0 1 0 0-1.5h-7.5zm0-2.5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 1 0 0-1.5h-3.5zm0 5a.75.75 0 1 0 0 1.5h3.5a.75.75 0 1 0 0-1.5h-3.5z"
      />
    </defs>
    <use fillRule="evenodd" transform="translate(-2)" xlinkHref="#contract-a" />
  </svg>
);
